import { useState, useEffect } from "react";
import axios from "axios";
import { getVideo } from "../../Service/Api";
import Breadcrumb from "../../Component/Breadcrumb";

function VideoGallery() {
  const [videoData, setVideoData] = useState([]);

  useEffect(() => {
    async function VideoDataApi() {
      try {
        const videoGet = await axios.get(getVideo());
        setVideoData(videoGet.data);
      } catch (error) {
        console.error("Error fetching video data:", error);
      }
    }

    VideoDataApi();
  }, []);

  return (
    <>
      <Breadcrumb>Gallery / Video Gallery</Breadcrumb>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Video Gallery</h1>
            </div>
          </div>

          {/* ===== Video Gallery ===== */}
          {videoData.length > 0 ? (
            <div className="row">
              {videoData.map((item, index) => (
                <div
                  className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 galleryCount"
                  key={index}
                >
                  <div className="gallery-inner">
                    <div className="gallery-blks video-blks">
                      <div className="backDiv"></div>

                      <img
                        src={item.thumbnail || "/Images/video_placeholder.jpg"}
                        className="img-fluid"
                        alt={item.title || "Video"}
                      />

                      <span className="video-play-icon">
                        <img src="/Images/yt_icon.svg" alt="Play" />
                      </span>
                    </div>

                    <div className="gallery-content">
                      <div className="gallery-title">
                        <h3>{item.title || "Video Title"}</h3>
                      </div>

                      <a
                        href={item.videoUrl || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="view-more"
                      >
                        Watch Video <i className="bi bi-play-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* ===== No Data / Dummy UI ===== */
            <div className="row">
              {[1, 2, 3].map((_, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={index}>
                  <div className="video_container d-flex align-items-center justify-content-between p-3">
                    {/* Image */}
                    <img
                      src="/Images/yt_icon.svg"
                      alt="Video Icon"
                      className="video_icon"
                    />

                    {/* Title */}
                    <h4 className="mb-0 video_title">Title</h4>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default VideoGallery;
